module.exports = "{{if playCount}}<li class=\"video_player\" style=\"float:left\"><div class=\"player_area\" id={{:parent}}></div><div class=\"wrap_cont\"> <a href={{:link}} class=\"tit_video\" target=\"_blank\" onclick=\"smartLog(this, 'dc=TVP&p=32&r=3&rc=1&pg=1&at=link&d={{:docId}}', event);\">{{:tit}}</a><div class=\"txt_info\"><span><span class=\"ico_tvp ico_play_s\"></span> {{:playCount}}</span> {{if regDate}} <span class=\"txt_upload\">업로드 : {{:regDate}}</span>{{/if}}</div></div></li> {{else}}<div class=\"player_area\" id=\"nowPlayer\"></div> {{/if}}";


/*****************
 ** WEBPACK FOOTER
 ** ./src/TVP/hbs/clip.hbs
 ** module id = 4
 ** module chunks = 0 1
 **/